import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { GenioHeader } from '../common/Header';
import { useAppState } from '../../contexts/appState';
import './Layout.css';
import { Toast } from '../common';

const GenioLayout = () => {
  const [appState] = useAppState();
  const location = useLocation();
  const pageType = location.pathname.replace('/genio', '').replace('/', '') || 'landing';
  if (pageType === 'landing') {
    localStorage.removeItem('selectedBusinessGenio');
  }
  return (
    <div className="App">
      <GenioHeader pageType={pageType} />
      <Outlet />
      {appState?.alertSnackbar?.message && <Toast toastMsgObj={appState?.alertSnackbar || {}} />}
    </div>
  );
};

export default GenioLayout;
